import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import PromoBanner from "@/components/sections/PromoBanner";
import About from "@/components/sections/About";
import Appointment from "@/components/sections/Appointment";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import StickyEmergencyCTA from "@/components/sections/StickyEmergencyCTA";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-slate-50">
      <Header />
      <main>
        <Hero />
        <Services />
        <PromoBanner />
        <About />
        <Appointment />
        <Contact />
      </main>
      <Footer />
      <StickyEmergencyCTA />
    </div>
  );
}
